module.exports = "https://static.wmbcdn.com/uniweb/images/f91e6c91e7228a7d5a9d987512a36dc7.svg";